<template>
  <div class="template">
    <!-- <div style="width: 100%; display: flex; align-items: center">
      <el-input
        v-model="templateValue"
        placeholder="请输入备件名称"
        style="width: calc(100% - 60px)"
      ></el-input>
      <el-button style="width: 60px" type="primary" @click="openDialog"
        ><i class="el-icon-search"></i
      ></el-button>
    </div> -->
    <el-dialog
      title="选择设备"
      top="5vh"
      :visible.sync="dialogVisible"
      width="70%"
      append-to-body
      :before-close="handleClose"
    >
      <div class="dialog-top">
        <el-input
          v-model="searchData.DeviceCode"
          clearable
          placeholder="请输入设备名称/编号"
          style="width: 250px; margin-left: 10px"
        ></el-input>

        <el-button
          type="primary"
          @click="handleSearch"
          style="margin-left: 10px"
          >查询</el-button
        >
      </div>
      <!-- @selection-change="handleSelect" -->
      <div class="dialog-center" v-loading="loading">
        <el-table
          :data="tableData"
          ref="dialogTable"
          style="width: 100%"
          height="calc(100% - 40px)"
          :class="type == 'checkBox' ? 'checkBoxTable' : 'radioTable'"
          @selection-change="handleSelectionChange"
          @select="handleSelect"
          @row-click="handleRowClick"
        >
          <el-table-column label="" width="50" type="selection">
          </el-table-column>
          <el-table-column label="序号" width="50" type="index">
          </el-table-column>

          <el-table-column label="设备编号" align="center" prop="DeviceCode">
          </el-table-column>
          <el-table-column label="设备名称" align="center" prop="device_name">
          </el-table-column>
          <el-table-column label="设备型号" align="center" prop="model_number">
          </el-table-column>
          <el-table-column label="设备规格" align="center" prop="specification">
          </el-table-column>
          <el-table-column
            label="生产厂家名称"
            align="center"
            prop="manufacturer"
          >
          </el-table-column>
          <el-table-column label="维修商名称" align="center" prop="maintenance">
          </el-table-column>
          <el-table-column
            label="安装位置"
            align="center"
            prop="InstallationAreaName"
          >
          </el-table-column>

          <!-- <el-table-column label="购置价格" align="center" prop="purchase_price">
        </el-table-column> -->
          <el-table-column label="购置日期" align="center" prop="purchase_date">
            <template slot-scope="scope">
              {{
                scope.row.purchase_date
                  ? moment(scope.row.purchase_date).format('YYYY-MM-DD')
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center" prop="State">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.State == 0">停机</el-tag>
              <el-tag type="success" v-if="scope.row.State == 1">开机</el-tag>
              <el-tag type="warning" v-if="scope.row.State == 2">故障</el-tag>
              <el-tag type="danger" v-if="scope.row.State == 3">报废</el-tag>
            </template>
          </el-table-column>
        </el-table>
        <div
          style="
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: right;
          "
        >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.PageIndex"
            :page-sizes="pagination.PageSizes"
            :page-size="pagination.PageRows"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
          >
          </el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  data() {
    return {
      moment,
      dialogVisible: false,
      templateValue: '',
      searchData: {
        DeviceCode: '',
        device_name: '',
        purchase_date: '',
      },
      selectRows: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      tableData: [],

      loading: false,
      selectedRows: [],
    }
  },
  props: {
    type: { default: 'checkBox', require: false, type: String },
    deviceType: { default: '', require: false, type: String },
  },
  methods: {
    confirm() {
      console.log(this.selectRows, '')
      if (this.selectRows.length <= 0) {
        return this.$notify.warning('请选择')
      }
      this.$emit('select', [...this.selectRows])
      this.dialogVisible = false
    },
    handleRowClick(row, column, event) {
      if (this.type == 'checkBox') {
        this.$refs.dialogTable.toggleRowSelection(row)
        return
      }
      this.$refs.dialogTable.clearSelection()
      this.$refs.dialogTable.toggleRowSelection(row)
      this.selectRows = [row]
    },
    handleSelect(selection, row) {
      console.log(selection, row)

      if (this.type == 'checkBox') {
        this.selectRows = selection
        return
      }
      this.$refs.dialogTable.clearSelection()
      this.$refs.dialogTable.toggleRowSelection(row)
      this.selectRows = [row]
    },
    handleSelectionChange(val) {
      console.log(val)
      if (this.type == 'checkBox') {
        this.selectRows = val
        return
      }
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post(
          '/Base_DeviceTreeManage/DeviceItem/GetDeviceItemUnrelatedAssets',
          {
            PageIndex: this.pagination.PageIndex,
            PageRows: this.pagination.PageRows,
            SortField: 'CreateTime',
            SortType: 'Desc',
            Search: {
              Keyword: this.searchData.DeviceCode,
            },
          }
        )
        .then((resJson) => {
          this.loading = false
          this.tableData = resJson.Data
          this.pagination.total = resJson.Total
          this.$nextTick(() => {
            this.$refs.dialogTable.clearSelection()
          })
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    openDialog() {
      this.dialogVisible = true
      this.searchData.DeviceCode = ''
      this.searchData.device_name = ''
      this.searchData.purchase_date = ''
      this.handleSearch()
    },
    handleClose() {
      this.dialogVisible = false
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {
    value(newValue) {
      this.templateValue = newValue
    },
  },
}
</script>
<style lang="scss" scoped>
.template {
  width: 100%;
}
::v-deep .el-dialog__body {
  padding: 20px;
  padding-top: 10px;
}
::v-deep .el-dialog__title {
  font-weight: bold;
}
.dialog-top {
  line-height: 30px;
}
.dialog-center {
  height: calc(70vh - 30px);
}
::v-deep
  .radioTable
  .el-table__header-wrapper
  .el-table-column--selection
  .cell {
  display: none;
}
</style>
